import { useNavigateTo } from '../../paths/useNavigateTo';
import { path } from '../../paths';
import { Forbidden } from '../Forbidden';
import { DataObjectGroupForm } from './DataObjectGroupForm';
import { useCallback } from 'react';
import {
  DataObjectGroupDto,
  PermissionCode,
  useHasPermission,
} from '@atlas-frontend/sdk';

export const DataObjectGroupCreate = () => {
  const navigateToDataObjectGroupDirectory = useNavigateTo(
    path.dataObjectGroupDirectory,
  );
  const navigateToDataObjectGroupEdit = useNavigateTo(path.dataObjectGroupEdit);

  const handleCancel = useCallback(() => {
    navigateToDataObjectGroupDirectory();
  }, [navigateToDataObjectGroupDirectory]);
  const handleSuccess = useCallback(
    (response: DataObjectGroupDto) => {
      navigateToDataObjectGroupEdit(
        { id: response.id },
        { state: { saved: 'success', noBlocker: true } },
      );
    },
    [navigateToDataObjectGroupEdit],
  );

  return (
    <Forbidden
      isAllowed={useHasPermission(PermissionCode.DATA_OBJECT_GROUP_MANAGE)}
    >
      <DataObjectGroupForm
        mode="create"
        onClickCancel={handleCancel}
        onSuccess={handleSuccess}
      />
    </Forbidden>
  );
};
